import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Building2, Users, LogOut, Lock, ExternalLink, Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import './Admin.css';

const AdminLayout = ({ children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };
  const close = () => setSidebarOpen(false);

  return (
    <div className="admin-layout">
      <button className="admin-menu-btn" onClick={() => setSidebarOpen(p => !p)}>
        {sidebarOpen ? <X size={20}/> : <Menu size={20}/>}
      </button>
      <aside className={"admin-sidebar" + (sidebarOpen ? ' open' : '')}>
        <div className="admin-sidebar__logo">
          <img src="/logo.png" alt="Smart Property Solutions" />
        </div>
        <nav className="admin-sidebar__nav">

          <div className="section-divider">Main</div>
          <NavLink to="/admin/dashboard" onClick={close}><LayoutDashboard size={17}/> Dashboard</NavLink>

          <div className="section-divider">Manage</div>
          <NavLink to="/admin/properties" onClick={close}><Building2 size={17}/> Properties</NavLink>
          <NavLink to="/admin/leads"      onClick={close}><Users size={17}/> Leads</NavLink>

          <div className="section-divider">Account</div>
          <NavLink to="/admin/change-password" onClick={close}><Lock size={17}/> Change Password</NavLink>
          <NavLink to="/" end target="_blank" rel="noreferrer" onClick={close}><ExternalLink size={17}/> View Website</NavLink>
          <button onClick={handleLogout}><LogOut size={17}/> Logout</button>

        </nav>
      </aside>
      <main className="admin-main">
        <div className="admin-topbar">
          <span className="admin-topbar__title">Admin Panel</span>
          <div className="admin-topbar__actions">
            <NavLink to="/admin/properties/new" className="btn-primary" style={{fontSize:'12px',padding:'9px 20px'}}>+ Add Property</NavLink>
          </div>
        </div>
        <div className="admin-content">{children}</div>
      </main>
      {sidebarOpen && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:199}} onClick={close}/>
      )}
    </div>
  );
};

export default AdminLayout;
